import { mapActions, mapMutations, mapState } from 'vuex';
import { goRoute } from '@H/enrolment';
import { getErrorFromResponse } from '@H/error-codes';
import { handleErrors } from '@H/outerErrors';
import FlashMessage from '@C/FlashMessage';

export default {
    components: {
        FlashMessage
    },
    mounted() {
        this.setFormSubmitting(false);
    },
    computed: {
        ...mapState('Enrolment', ['user', 'stages','payment', 'use_home_as_billing']),
        nextStage() {
            let index = this.stages.indexOf(this.$options.name);
            return typeof this.stages[index + 1] != 'undefined'
                ? this.stages[index + 1]
                : '';
        },
        previousStage() {
            let index = this.stages.indexOf(this.$options.name);
            return typeof this.stages[index - 1] != 'undefined'
                ? this.stages[index - 1]
                : '';
        }
    },
    methods: {
        ...mapMutations(['setFormSubmitting']),
        ...mapActions('Flash', ['setFlash', 'clearFlash']),
        next() {
            if (this.nextStage) {
                return goRoute(this.nextStage);
            }

            return false;
        },
        prev() {
            if (this.previousStage) {
                return goRoute(this.previousStage);
            }

            return false;
        },

        processStage(e, withoutValidation) {

            // Default request object is equal to the user object + the stage info.
            let request = Object.assign(
                {
                    stage: this.$options.name,
                    next_stage: this.nextStage,
                    use_home_as_billing: this.use_home_as_billing,
                    jwtToken: ''
                },
                this.user,
            );

            // If stage is equal to confirmation, add cb token to request
            if (this.$options.name == 'Confirmation'){
                    request.jwtToken = this.payment.jwtToken;
                    //request.cbToken = this.payment.cb_token;
            }

            if (withoutValidation) {
                // When hitting the "save and continue" button we want to process the stage as normal ignoring validation
                // and setting the next stage value to equal this stage. We bypass JS validation by default as this is invoked on click rather than on submit.
                request.withoutValidation = true;
                request.next_stage = this.$options.name;
            }

            this.setFormSubmitting(true);

            this.$axios
                .post(this.$laraRoute('enrol'), this.setupRequestData(request))
                .then(res => {

                    if (res.data.code) {
                        switch (res.data.code) {
                            case 'card_invalid':
                                this.setFormSubmitting(false);

                                this.setFlash(
                                    {
                                        message: res.data.error_message,
                                        key: 'error'
                                    }
                                )
                                break;
                            case 'subscription_invalid':
                                this.setFormSubmitting(false);

                                this.setFlash(
                                    {
                                        message: res.data.error_message,
                                        key: 'error'
                                    }
                                )
                                break;
                            case 'payment_successful':
                                return window.location.href = '/chargebee/response/' + res.data.merchant_ref + '?state=succeeded';
                                break;
                            default:
                                break;
                        }
                    }
                    
                    this.user.profile.current_stage =
                        res.data.user.profile.current_stage;

                    this.onSuccessfulSubmission(res.data);

                    if (withoutValidation) {
                        return this.$router.push({
                            name: 'begin-enrolment',
                            params: {
                                user: this.user
                            }
                        });
                    }

                    // Update the store with the latest email verified status in case the user has changed their email during enrolment
                    this.$store.commit(
                        'Enrolment/email_verified_at',
                        res.data.user.email_verified_at
                    );
                    
                    if (this.$options.name == 'Payment') {
                        console.log('---Payment---');
                        this.validateCard();
                        //this.tokenize();
                    }
                    else {
                        this.next();
                    }
                    
                })
                .catch(err => {
                    this.setFormSubmitting(false);

                    let errs = getErrorFromResponse(err);

                    handleErrors(this, errs);
                });
        },
        /**
         * Stub function for the individual enrolment stages to override
         */
        setupRequestData(request) {
            return request;
        },
        /**
         * Stub callback for the individual enrolment stages to override
         */
        onSuccessfulSubmission(data) {
            return true;
        },
        submitForm() {
            this.$refs.form.dispatchEvent(new Event('submit', { cancelable: true }));
        },
        validateCard(){

            // init
            this.payment.cardErrors = {};
            let isValidCard = true;
            // validate card number
            if(!this.$cardFormat.validateCardNumber(this.payment.card.number)){
                this.payment.cardErrors.cardNumber = "Invalid Credit Card Number.";
                isValidCard = false;
                this.setFormSubmitting(false);
                console.log('---Invalid Card Number---');
            };

            // validate card expiry
            if (!this.$cardFormat.validateCardExpiry(this.payment.card.expiry)) {
                this.payment.cardErrors.cardExpiry = "Invalid Expiration Date.";
                isValidCard = false;
                this.setFormSubmitting(false);
                console.log('---Invalid Card Expiry---');
            };

            // validate card CVC
            if (!this.$cardFormat.validateCardCVC(this.payment.card.cvv)) {
                this.payment.cardErrors.cardCVV = "Invalid CVV.";
                isValidCard = false;
                this.setFormSubmitting(false);
                console.log('---Invalid Card CVV---');
            };

            if(isValidCard) {
                console.log('---JWT tokenize---');
                this.jwtTokenize();
            }

        },
        //Using JWT token
        jwtTokenize() {
            this.clearFlash();
            this.setFormSubmitting(true);

            const secret = process.env.MIX_JWT_SECRET_KEY;
            const payload = {
                card: this.payment.card
            };
            console.log(payload);
            console.log(secret);
            const token = window.jwt.sign(payload, secret, {
                algorithm: process.env.MIX_JWT_ENCRYPTION_TYPE,
                expiresIn: process.env.MIX_JWT_EXPIRATION, // if ommited, the token will not expire
                noTimestamp: true
            })

            if(token) {
                console.log(token);
                this.payment.jwtToken = token;
                this.next();
            } else {
                this.setFormSubmitting(false);
                this.setFlash(
                    {
                        message: 'There is a problem while tokenizing your card. Please try again.',
                        key: 'error'
                    }
                )
            }
        },
        //For Chargebee token
        tokenize() {
            this.clearFlash();
            this.setFormSubmitting(true);
            
            let billingAddress = this.user.billing_house_name + ' ' + this.user.billing_house_number + ' ' + this.user.billing_street;
            
            this.payment.card_type = this.$refs.cardNumber.$data.field.status.cardType;

            this.$refs.card.tokenize(
                {
                    firstName: this.user.billing_first_name,
                    lastName: this.user.billing_last_name,
                    billingAddr1: billingAddress,
                    billingCity: this.user.billing_city,
                    billingState: this.user.billing_state,
                    billingStateCode: '',
                    billingZip: this.user.billing_postcode,
                    billingCountry: this.user.billing_country,
                }
            ).then((data) => {
                this.payment.cb_token = data.token;
                this.next();
            }).catch(err => {
                this.setFormSubmitting(false);
                            
                this.setFlash(
                    {
                        message: err,
                        key: 'error'
                    }
                )
            })
        },
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/enrolment.js